
(function attachAddToCartHandler() {
  function setup() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form || form.dataset.bound === "true") return;

    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    newForm.dataset.bound = "true"; // Mark as bound to prevent re-attachment

    newForm.addEventListener("submit", function (e) {
      e.preventDefault();
      const formData = new FormData(newForm);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((res) => {
          if (!res.ok) throw new Error("Add to Cart failed");
          return res.json();
        })
        .then((data) => {
          console.log("✅ Product added to cart:", data);
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.error("❌ Error adding to cart:", err);
          alert("Something went wrong adding to cart. Please try again.");
        });
    });

    console.log("🛠️ Add to Cart handler attached");
  }

  const observer = new MutationObserver(setup);
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial try
  document.addEventListener("DOMContentLoaded", setup);
})();
